import { useEffect, useState } from 'react';
import './orgAccount.css';
import ReactLoading from 'react-loading';
import errorHandle from '../../utils/errorHandle';
import AccOwner from './orgAccSec/AccOwner';
import AccCompany from './orgAccSec/AccCompany';
import AccAddress from './orgAccSec/AccAddress';
import AccContactPer from './orgAccSec/AccContactPer';
import AccBank from './orgAccSec/AccBank';
import { FetchOrgAccount } from './orgAccountFun/fetchOrgAccount';
import OrgInfo from './orgAccSec/orgInfo';
import Dialog from '../../components/dialogModal/dialogModal';
import { toast } from 'react-toastify';
import CharCount from '../../components/charCount/CharCount';
import { editOrgAccount } from './orgAccountFun/editOrgAccount';
import fileUpload from '../../utils/fileUpload';
import deleteFile from '../../utils/deleteFile';
import AccPercentage from './orgAccSec/AccPercentage';
import { getType } from '../../utils/getType';

export default function OrgAccount() {
    const [accDetails, setAccDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [accountData, setAccountData] = useState({ about: '', logo: '' });
    const [render, setRender] = useState(false);
    const [newLogoFile, setNewLogoFile] = useState(null);
    const [logoUploading, setLogoUploading] = useState(false);
    const pathParts = window.location.pathname.split('/');

    const type = ['a', 'c', 'g'].includes(pathParts[2]) ? pathParts[2] : 'trip';

    const typeMap = {
        a: 'act',
        g: 'gu',
        c: 'camp',
        trip: 'trip'
    };

    useEffect(() => {
        async function fetchAccData() {
            setLoading(true);
            try {
                await FetchOrgAccount(setAccDetails, setLoading, typeMap[type]);
            } catch (error) {
                setLoading(false);
                errorHandle(error);
            }
        }

        fetchAccData();
    }, [render]);

    useEffect(() => {
        if (accDetails?.about !== accountData.about || accDetails?.logo !== accountData.logo) {
            setAccountData({
                about: accDetails?.about ?? '',
                logo: accDetails?.logo ?? ''
            });
        }
    }, [accDetails]);

    const handelLogo = async (e) => {
        if (e.target.files) {
            //Without conversiotion to array it we cant store or read it as array
            const selectedFile = e.target.files[0];

            const sizeLimit = 2 * 1024 * 1024; // 2 MB in bytes
            // check if all the files are less than 2mb
            const checkImg = selectedFile.size > sizeLimit;
            if (checkImg) {
                toast.error('Image size should be less than 2 mb');
                return;
            }
            setNewLogoFile(selectedFile);
            setAccountData((prevState) => {
                return {
                    ...prevState,
                    logo: URL.createObjectURL(selectedFile)
                };
            });
        } else {
            return;
        }
    };

    const handelEdit = async () => {
        setLogoUploading(true);
        let finalData = { ...accountData };
        try {
            if (newLogoFile) {
                const type = localStorage.getItem('type');
                if (accDetails?.logo) await deleteFile(accDetails.logo);
                const logoUrl = await fileUpload(newLogoFile, type, 'create', 'logo');
                finalData.logo = logoUrl;
            }
        } catch (error) {
            toast.error('Logo upload failed');
        } finally {
            setLogoUploading(false);
        }
        editOrgAccount(finalData, setLoading, setModal, setRender, type);
    };

    console.log(accDetails, 'accDetails');

    return (
        <div className='orgAccountDiv'>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {Object.keys(accDetails).length === 0 && !loading ? (
                <p className='orgAccountLabel'>No data found</p>
            ) : (
                <>
                    <h1 className='orgAccountH1'>Welcome {accDetails.companyName}</h1>
                    <OrgInfo setModal={setModal} accDetails={accDetails} />
                    <AccOwner accDetails={accDetails} />
                    <AccCompany accDetails={accDetails} />
                    <AccAddress accDetails={accDetails} />
                    <AccContactPer accDetails={accDetails} />
                    <AccBank accDetails={accDetails} />
                    <AccPercentage accDetails={accDetails} />
                </>
            )}
            {modal && (
                <Dialog openModal={modal} heading={'Edit Account'}>
                    <div className='dialogContent'>
                        <div className=''>
                            <label className='orgAccounProfiletp'>Logo</label>
                            <div className='orgAccImgContainer'>
                                <input
                                    type='file'
                                    multiple
                                    accept='.jpg, .jpeg, .png'
                                    className=''
                                    onChange={(e) => handelLogo(e)}
                                />
                            </div>
                        </div>
                        <div className='imgDisplayDiv'>
                            {accountData?.logo && <img src={accountData.logo} alt='logo' className='wallImgDisp' />}
                            {logoUploading && (
                                <div className='uploadLoader centerLoader'>
                                    <ReactLoading type='spin' color='#006aff' height={30} width={30} />
                                </div>
                            )}
                        </div>

                        <label className='orgAccounProfiletp'>About</label>
                        <textarea
                            className='messageArea'
                            value={accountData?.about}
                            onChange={(e) =>
                                setAccountData({
                                    ...accountData,
                                    about: e.target.value
                                })
                            }
                        />
                        <CharCount string={accountData.about ? accountData.about : ''} min={20} limit={200} />
                        <div className='alignCenter'>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setModal(false);
                                    setAccountData({
                                        about: accDetails?.about ?? '',
                                        logo: accDetails?.logo ?? ''
                                    });
                                }}
                            >
                                Cancel
                            </button>
                            <button className='dialogActBtn submit' onClick={handelEdit}>
                                Submit
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
}
